<template>
  <div id="app">
    <!-- 加载页面 -->
    <Loading :style="{zIndex: 9999}" :visible="isLoading" />
    <!-- 主内容 -->
    <router-view :visible="!isLoading" />
  </div>
</template>

<script>
import $ from 'jquery';
import Loading from '@/components/Loading.vue';
import { initWechatShare, setWechatShare, isWechat, getCurrentUrl } from '@/utils/wechatShare';
// 打开手机端控制台
// import VConsole from "vconsole";
// new VConsole();

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    // 预加载图片资源
    this.preloadImages();
    // 初始化微信分享
    this.initWechatConfig();
  },
  methods: {
    // 预加载图片
    preloadImages() {
      const images = [
        require('@/assets/bg_map.png'),
        'https://lbs-nfncb.nfncb.cn/gzmap/img/marker.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark1.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark2.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark3.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark4.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark5.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark6.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/mark7.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/search.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/line.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/news.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon1.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon2.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon3.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon4.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon5.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon6.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon7.png',
        'https://lbs-nfncb.nfncb.cn/gzmap/img/icon8.png',
        // 'https://lbs-nfncb.nfncb.cn/gzmap/img/bg_map.png',
        require('@/assets/bg1.png'),
        require('@/assets/bg2.png'),
        require('@/assets/bg3.png'),
        require('@/assets/bg4.png'),
        // "https://lbs-nfncb.nfncb.cn/ueditor/BFVNLqLfj7BZfHnd9BD5OW0A7Vh2jdSAuu1Ff8b3.png"
      ];
      
      let loadedCount = 0;
      const totalImages = images.length;
      
      images.forEach((src, index) => {
        const img = new Image();
        img.onload = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            this.onImagesLoaded();
          }
        };
        img.onerror = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            this.onImagesLoaded();
          }
        };
        img.src = src;
      });
      
      // 如果图片列表为空，直接触发完成事件
      if (totalImages === 0) {
        this.onImagesLoaded();
      }
    },
    // 图片加载完成
    onImagesLoaded() {
      // 延迟一点时间，让加载动画更流畅
      setTimeout(() => {
        this.isLoading = false;
      }, 1500);
    },
    // 初始化微信配置
    async initWechatConfig() {
      // 检查是否在微信环境中
      if (!isWechat()) {
        console.log('不在微信环境中，跳过微信分享配置')
        return
      }

      try {
        // 获取当前页面URL（去除hash）
        const url = getCurrentUrl()
        
        // 调用接口获取微信JS-SDK配置
        const response = await this.$api.get('/api/wechat/getJssdkConfig', {
          params: {
            url: url
          }
        })
        
        const data = response && response.data
        console.log('response:', data);
        if (data && data.message === 'success' && data.data) {
          const config = data.data
          
          // 初始化微信分享配置
          await initWechatShare({
            appId: config.appId,
            timestamp: config.timestamp,
            nonceStr: config.nonceStr,
            signature: config.signature
          })

          // 获取分享图片的完整URL（share.png在public目录下）
          const shareImgUrl = `${window.location.origin}/gzmap/share.png`
          console.log('shareImgUrl:', shareImgUrl);
          
          // 设置默认分享内容
          setWechatShare({
            title: '穗农集',
            desc: '美食畅享、乡村畅游，尽在“穗农集”',
            link: url,
            imgUrl: shareImgUrl
          })

          console.log('微信分享配置成功')
        } else {
          console.warn('获取微信配置失败:', data)
        }
      } catch (error) {
        console.error('初始化微信配置失败:', error)
      }
    }
  }
}
</script>
 
<style >

#app {
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
